import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import {
    trackDetailViewSelector, visibleTracksSelector,
    highlightedDriveSelector, trackDataSelector,
} from '../../../features/datacenter/historySlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const OsmMapTrackBounder = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const trackDetailView = useSelector(trackDetailViewSelector);
    const visibleTracks = useSelector(visibleTracksSelector);
    const highlightedDrive = useSelector(highlightedDriveSelector);
    const trackData = useSelector(trackDataSelector);

    useEffect(() => {
        const mapBounder = () => {
            if (map) {
                let bounds = [];
                if (visibleTracks.length > 0) {
                    if (highlightedDrive.startIndex !== null && highlightedDrive.endIndex !== null && trackDetailView) {
                        //console.log("drive bound", highlightedDrive);
                        const route = trackData[trackDetailView].track;
                        route.forEach((r, i) => {
                            if (i >= highlightedDrive.startIndex && i <= highlightedDrive.endIndex) {
                                bounds.push([r.lat, r.lng]);
                            }
                        })
                        map.fitBounds(bounds, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                    } else if (trackDetailView) {
                        //console.log("Track bound", trackDetailView);
                        const route = trackData[trackDetailView].track;
                        if (route) {
                            route.forEach((r, i) => {
                                bounds.push([r.lat, r.lng]);
                            })
                            map.fitBounds(bounds, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                            dispatch(setNeedBounding(false));
                        }

                    } else {
                        //console.log("all bound");
                        visibleTracks.forEach(v => {
                            if (trackData[v]) {
                                const route = trackData[v] && trackData[v].track;
                                route.forEach((r, i) => {
                                    bounds.push([r.lat, r.lng]);
                                })
                                map.fitBounds(bounds, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                            }
                        })
                        dispatch(setNeedBounding(false));
                    }
                }
            }

        };
        mapBounder();
    }, [dispatch, map, highlightedDrive, trackDetailView, visibleTracks, trackData])

    return (
        <div></div>
    );
}

export default OsmMapTrackBounder;